// extracted by mini-css-extract-plugin
export default {"back":"ModalWindow_back__1RB57","active":"ModalWindow_active__mk16h","modal":"ModalWindow_modal__6oDr4"};